import * as AuthModulePages from '@Modules/auth/pages';
import * as HomeModulePages from '@Modules/home/pages';
import * as ReportingModulePages from '@Modules/reporting/pages';

// Admin Module
import * as AdminModulePages from '@Modules/admin/pages';

import adminModuleRoutes from '@Modules/admin/AdminModuleRoutes';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import URLConfig from './config/urls/url.config';
import { AppLayout } from './layouts';
import NotFound from './modules/core/pages/NotFound';
import React from 'react';
import CardManagemenSystemLayout from '@Modules/cardManagementSystem/CardManagemenSystemLayout';
import CardManagementSystemRoutes from '@Modules/cardManagementSystem/CardManagementSystemRoutes';
import ReportingRoutes from '@Modules/reporting/ReportingRoutes';
import TerminalManagementSystemLayout from '@Modules/terminalManagementSystem/TerminalManagemenSystemLayout';
import TerminalManagementSystemRoutes from '@Modules/terminalManagementSystem/TerminalManagementSystemRoutes';
import TransactionLayout from '@Modules/transaction/TransactionLayout';
import TransactionRoutes from '@Modules/transaction/TransactionRoutes';
import BatchesProcessingLayout from '@Modules/batchesProcessing/BatchesProcessingLayout';
import BatchesProcessingRoutes from '@Modules/batchesProcessing/BatchesProcessingRoutes';
import InterfaceLayout from '@Modules/interfaceManagement/interface/InterfaceLayout';
import InterfaceRoutes from '@Modules/interfaceManagement/interface/InterfaceRoutes';
import VisaBase2Layout from '@Modules/interfaceManagement/visaBase2/VisaBase2Layout';
import VisaBase2Routes from '@Modules/interfaceManagement/visaBase2/VisaBase2Routes';
import FraudManagementLayout from '@Modules/fraudManagement/FraudManagementLayout';
import FraudManagementRoutes from '@Modules/fraudManagement/FraudManagementRoutes';
import GimacRoutes from '@Modules/interfaceManagement/gimac/GimacRoutes';
import GimacLayout from '@Modules/interfaceManagement/gimac/GimacLayout';

const AppRoutes: React.FC = () => {
  return (
    <>
      <BrowserRouter>
        <Routes>
          {/* Redirect Root to Login page */}
          <Route path="/" element={<Navigate to={URLConfig.AUTH.LOGIN} />} />

          <Route path={URLConfig.ROOT} element={<AppLayout />}>
            {/* Home Routes */}
            <Route
              path={URLConfig.HOME.DASHBOARD}
              element={<HomeModulePages.Home />}
            />
            <Route
              path={URLConfig.HOME.PROFILE}
              element={<HomeModulePages.Profile />}
            />
            {/* Reporting Routes */}
            <Route
              path={URLConfig.REPORTING.ROOT}
              element={<ReportingModulePages.ReportingRoot />}
            >
              <Route
                path={URLConfig.REPORTING.TRANSACTIONS}
                element={<ReportingModulePages.Transactions />}
              />
              <Route
                path={URLConfig.REPORTING.CARDHOLDERS}
                element={<ReportingModulePages.Cardholders />}
              />
              <Route
                path={URLConfig.REPORTING.PREPAID}
                element={<ReportingModulePages.Prepaid />}
              />
              <Route
                path={URLConfig.REPORTING.MERCHANT}
                element={<ReportingModulePages.Merchant />}
              />
              {ReportingRoutes.map((reportingRoute, index) => (
                <React.Fragment key={index}>{reportingRoute}</React.Fragment>
              ))}
            </Route>

            {/* Auth Internal Routes */}
            <Route path={URLConfig.AUTH.DASHBOARD}>
              {/* <Route
                path={URLConfig.AUTH.LOGIN}
                element={<AuthModulePages.Login />}
              /> */}
            </Route>

            {/* Admin Routes */}
            <Route
              path={URLConfig.ADMIN.ROOT}
              element={<AdminModulePages.AdminLayout />}
            >
              {adminModuleRoutes.map((adminRoute, index) => (
                <React.Fragment key={index}>{adminRoute}</React.Fragment>
              ))}
            </Route>

            {/* Card Management Routes */}
            <Route
              path={URLConfig.CARD_MANAGEMENT_SYSTEM.ROOT}
              element={<CardManagemenSystemLayout />}
            >
              {CardManagementSystemRoutes.map((CardManagementSystemRoute, index) => (
                <React.Fragment key={index}>{CardManagementSystemRoute}</React.Fragment>
              ))}
            </Route>

            {/* Terminal Management Routes */}
            <Route
              path={URLConfig.TERMINAL_MANAGEMENT_SYSTEM.ROOT}
              element={<TerminalManagementSystemLayout />}
            >
              {TerminalManagementSystemRoutes.map((TerminalManagementSystemRoute, index) => (
                <React.Fragment key={index}>{TerminalManagementSystemRoute}</React.Fragment>
              ))}
            </Route>
            {/* Transaction Routes */}
            <Route
              path={URLConfig.TRANSACTION.ROOT}
              element={<TransactionLayout />}
            >
              {TransactionRoutes.map((TransactionRoute, index) => (
                <React.Fragment key={index}>{TransactionRoute}</React.Fragment>
              ))}
            </Route>
            {/* Batches Processing Routes */}
            <Route
              path={URLConfig.BATCHES_PROCESSING.ROOT}
              element={<BatchesProcessingLayout />}
            >
              {BatchesProcessingRoutes.map((BatchesProcessingRoute, index) => (
                <React.Fragment key={index}>{BatchesProcessingRoute}</React.Fragment>
              ))}
            </Route>

            {/* Interface Routes */}
            <Route
              path={URLConfig.INTERFACE_MANAGEMENT.INTERFACE.ROOT}
              element={<InterfaceLayout />}
            >
              {InterfaceRoutes.map((InterfaceRoute, index) => (
                <React.Fragment key={index}>{InterfaceRoute}</React.Fragment>
              ))}
            </Route>


            {/* VisaBase2 Routes */}
            <Route
              path={URLConfig.INTERFACE_MANAGEMENT.VISA_BASE_II.ROOT}
              element={<VisaBase2Layout />}
            >
              {VisaBase2Routes.map((VisaBase2Route, index) => (
                <React.Fragment key={index}>{VisaBase2Route}</React.Fragment>
              ))}
            </Route>

            {/* Fraud Management Routes */}
            <Route
              path={URLConfig.FRAUD_MANAGEMENT.ROOT}
              element={<FraudManagementLayout />}
            >
              {FraudManagementRoutes.map((FraudManagementRoute, index) => (
                <React.Fragment key={index}>{FraudManagementRoute}</React.Fragment>
              ))}
            </Route>

            {/* GIMAC Routes */}
            <Route
              path={URLConfig.INTERFACE_MANAGEMENT.GIMAC.ROOT}
              element={<GimacLayout />}
            >
              {GimacRoutes.map((GimacRoute, index) => (
                <React.Fragment key={index}>{GimacRoute}</React.Fragment>
              ))}
            </Route>


            {/* Not found */}
            {/* <Route path={URLConfig.NOT_FOUND} element={<NotFound />} />
            <Route path="*" element={<Navigate to={URLConfig.NOT_FOUND} />} /> */}
          </Route>

          {/* Auth Module External Routes */}
          <Route
            path={URLConfig.AUTH.ROOT}
            element={<AuthModulePages.AuthLayout />}
          >
            <Route
              path={URLConfig.AUTH.LOGIN}
              element={<AuthModulePages.Login />}
            />

            <Route
              path={URLConfig.AUTH.PASSWORD_FORGOT}
              element={<AuthModulePages.PasswordForgot />}
            />
          </Route>

          <Route path={URLConfig.NOT_FOUND} element={<NotFound />} />
          <Route path="*" element={<Navigate to={URLConfig.NOT_FOUND} />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default AppRoutes;
